
/**
 * Parsing JSON APIs can get convoluted because the .json() method is async. This is a helper to speed things along.
 * Have modified this so it fails on anything but a 200 OK.
 * NOTE: Haven't tested redirect support (301s, etc)
 * Source: https://github.com/github/fetch/issues/240#issuecomment-161219159
 * @param url
 * @param options
 * @returns {Promise<Response>}
 */
export function fetchJSON(url, options) {
    let isCachedResponse = false;
    const startTime = Date.now();
    // TODO: temporary fix to htaccess issues
    return fetch('/index.php' + url, options).then(function(response) {
        return response.json().then(function(data) {
            // Use duration to guess if response came from browser cache
            const duration = (Date.now() - startTime);
            if (duration < 50) {
                isCachedResponse = true;
            }
            const result = { status: response.status, headers: response.headers, json: data, isCachedResponse: isCachedResponse };
            if (response.status !== 200 || (typeof data.success !== 'undefined' && !data.success)) {
                result.success = false;
                return Promise.reject(result);
            }
            result.success = true;
            return result;
        })
    })
}

export function fetchJSONPre(url, options) {
    let isCachedResponse = false;
    const startTime = Date.now();
    // TODO: temporary fix to htaccess issues
    return fetch(url, options).then(function(response) {
        return response.json().then(function(data) {
            // Use duration to guess if response came from browser cache
            const duration = (Date.now() - startTime);
            if (duration < 50) {
                isCachedResponse = true;
            }
            const result = { status: response.status, headers: response.headers, json: data, isCachedResponse: isCachedResponse };
            if (response.status !== 200 || (typeof data.success !== 'undefined' && !data.success)) {
                result.success = false;
                return Promise.reject(result);
            }
            result.success = true;
            return result;
        })
    })
}
